import DashboardHeader from "./DashboardHeader";

// Skeleton placeholders for the dashboard while data loads. Mirrors
// the final layout (This Week left; NeedsAttention + Ask Sacristy AI
// stacked right) so the page doesn't reflow when the data arrives.
//
// Each block has aria-hidden="true" because it's a visual placeholder,
// not real content; the page-level aria-live region announces the
// "Loading…" state for screen readers.
export default function DashboardSkeleton() {
  return (
    <main className="page page--dashboard" aria-busy="true" aria-live="polite">
      <DashboardHeader />

      <p className="skeleton__sr-only">Loading dashboard…</p>

      <div className="dashboard__grid">
        <section className="panel skeleton-panel" aria-hidden="true">
          <div className="skeleton skeleton--title" />
          <div className="skeleton skeleton--row" />
          <div className="skeleton skeleton--row" />
          <div className="skeleton skeleton--row" />
          <div className="skeleton skeleton--row" />
          <div className="skeleton skeleton--row" />
        </section>

        <section className="panel skeleton-panel" aria-hidden="true">
          <div className="skeleton skeleton--title" />
          <div className="skeleton skeleton--card" />
          <div className="skeleton skeleton--card" />
        </section>

        <section className="panel skeleton-panel chat-skeleton" aria-hidden="true">
          <div className="skeleton skeleton--title" />
          <div className="skeleton skeleton--row" />
        </section>
      </div>
    </main>
  );
}
